/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateMerchantDefaultRuleFromFlowIdDto,
  GetMerchantDefaultRulesPaged1Params,
  InfiniteScrollListMerchantDefaultRuleDtoVoid,
  MerchantDefaultRuleDto,
  UpdateMerchantAutoAccountingRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMerchantDefaultRulesControllerDeprecated<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name UpdateMerchantDefaultRuleById1
   * @request PUT:/api/v1/merchant-category/id/{id}
   * @deprecated
   */
  updateMerchantDefaultRuleById = (
    id: string,
    data: UpdateMerchantAutoAccountingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/merchant-category/id/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateMerchantDefaultRuleByIdPath = '/v1/merchant-category/id/${id}'
  static updateMerchantDefaultRuleByIdMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name DeleteMerchantDefaultRuleById1
   * @request DELETE:/api/v1/merchant-category/id/{id}
   * @deprecated
   */
  deleteMerchantDefaultRuleById = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-category/id/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteMerchantDefaultRuleByIdPath = '/v1/merchant-category/id/${id}'
  static deleteMerchantDefaultRuleByIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name GetMerchantDefaultRuleByFlowId1
   * @request GET:/api/v1/merchant-category/{flowId}
   * @deprecated
   */
  getMerchantDefaultRuleByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<MerchantDefaultRuleDto, any>({
      path: `/v1/merchant-category/${flowId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMerchantDefaultRuleByFlowIdPath = '/v1/merchant-category/${flowId}'
  static getMerchantDefaultRuleByFlowIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name CreateMerchantDefaultRuleFromFlowId1
   * @request POST:/api/v1/merchant-category/{flowId}
   * @deprecated
   */
  createMerchantDefaultRuleFromFlowId = (
    flowId: string,
    data: CreateMerchantDefaultRuleFromFlowIdDto,
    params: RequestParams = {},
  ) =>
    this.http.request<MerchantDefaultRuleDto, any>({
      path: `/v1/merchant-category/${flowId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMerchantDefaultRuleFromFlowIdPath = '/v1/merchant-category/${flowId}'
  static createMerchantDefaultRuleFromFlowIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name DeleteMerchantAutoAccountingByFlowId1
   * @request DELETE:/api/v1/merchant-category/{flowId}
   * @deprecated
   */
  deleteMerchantAutoAccountingByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-category/${flowId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteMerchantAutoAccountingByFlowIdPath = '/v1/merchant-category/${flowId}'
  static deleteMerchantAutoAccountingByFlowIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name GetMerchantDefaultRulesPaged1
   * @request GET:/api/v1/merchant-category/paged
   * @deprecated
   */
  getMerchantDefaultRulesPaged = (
    query: GetMerchantDefaultRulesPaged1Params,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListMerchantDefaultRuleDtoVoid, any>({
      path: `/v1/merchant-category/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMerchantDefaultRulesPagedPath = '/v1/merchant-category/paged'
  static getMerchantDefaultRulesPagedMethod = 'GET'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name GetMerchantDefaultRulesByOrgId1
   * @request GET:/api/v1/merchant-category/list
   * @deprecated
   */
  getMerchantDefaultRulesByOrgId = (params: RequestParams = {}) =>
    this.http.request<MerchantDefaultRuleDto[], any>({
      path: `/v1/merchant-category/list`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMerchantDefaultRulesByOrgIdPath = '/v1/merchant-category/list'
  static getMerchantDefaultRulesByOrgIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name DeleteDefaultVatByFlowId1
   * @request DELETE:/api/v1/merchant-category/{flowId}/vat
   * @deprecated
   */
  deleteDefaultVatByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-category/${flowId}/vat`,
      method: 'DELETE',
      ...params,
    })

  static deleteDefaultVatByFlowIdPath = '/v1/merchant-category/${flowId}/vat'
  static deleteDefaultVatByFlowIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name DeleteDefaultSupplierAccountByFlowId1
   * @request DELETE:/api/v1/merchant-category/{flowId}/supplier-account
   * @deprecated
   */
  deleteDefaultSupplierAccountByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-category/${flowId}/supplier-account`,
      method: 'DELETE',
      ...params,
    })

  static deleteDefaultSupplierAccountByFlowIdPath =
    '/v1/merchant-category/${flowId}/supplier-account'
  static deleteDefaultSupplierAccountByFlowIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-merchant-default-rules-controller-deprecated
   * @name DeleteDefaultSubCategoryByFlowId1
   * @request DELETE:/api/v1/merchant-category/{flowId}/sub-category
   * @deprecated
   */
  deleteDefaultSubCategoryByFlowId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/merchant-category/${flowId}/sub-category`,
      method: 'DELETE',
      ...params,
    })

  static deleteDefaultSubCategoryByFlowIdPath = '/v1/merchant-category/${flowId}/sub-category'
  static deleteDefaultSubCategoryByFlowIdMethod = 'DELETE'
}
